<div [class.grid]="cards.length > 1" [class.grid-i2]="cards.length > 1">
    @for (card of cards; track $index) {
        <tec-card-access
            [title]="card.title"
            [tagImage]="{ icon: card.icon, status: 'default' }"
            size="md"
            (click)="card.fn($event)"
        />
    }
</div>
